import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Saniye cinsinden süreyi "mm:ss" formatına dönüştürür
 * @param seconds - Saniye cinsinden süre
 * @returns "mm:ss" formatında süre
 */
export function formatDuration(seconds: number): string {
  if (!seconds) return '00:00';
  
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
  
  return `${formattedMinutes}:${formattedSeconds}`;
}

/**
 * Saniye cinsinden süreyi "hh:mm:ss" veya "mm:ss" formatına dönüştürür
 * Eğer saat değeri 0 ise, sadece "mm:ss" formatında gösterilir
 * @param seconds - Saniye cinsinden süre
 * @returns "hh:mm:ss" veya "mm:ss" formatında süre
 */
export function formatDurationWithHours(seconds: number): string {
  if (!seconds) return '00:00';
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
  
  // Eğer saat değeri 0 ise, sadece dakika ve saniyeyi göster
  if (hours === 0) {
    return `${formattedMinutes}:${formattedSeconds}`;
  }
  
  // Saat değeri varsa, saat:dakika:saniye formatında göster
  const formattedHours = hours.toString().padStart(2, '0');
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}
